// Core
import React from 'react';

//Redux
import { connect } from 'react-redux';
import { updateBotsFilters } from '../../actions';

// Components
import { BaseStat } from '../BaseStat';
import { GeckoRow } from 'ui';
import FilterBar from '../../components/FilterBar';

// Widgets
import SuccessfulMessages from './widgets/SuccessfulMessages';
import TimeSaved from './widgets/TimeSaved';
import ResolvedConversations from './widgets/ResolvedConversations';
import ConversationLength from './widgets/ConversationLength';
import ClosedConversations from './widgets/ClosedConversation';

// Utilities
import moment from 'moment';

export class Bots extends BaseStat {
  widgets = [
    {
      title: 'Resolved Conversations',
      description:
        'The number of conversations the bot successfully resolved & closed without passing to a human',
      render: () => (
        <ResolvedConversations
          botsResolvedConversations={this.props.botsResolvedConversations}
          id="ResolvedConversations"
          currentPeriod={this.props.currentPeriod}
        />
      ),
    },
    {
      title: 'Message Success Rate',
      description: `The number of messages the bot successfully responded to with an answer that wasn't marked with ‘Not Useful’`,
      render: () => (
        <SuccessfulMessages
          id="SuccessfulMessages"
          currentPeriod={this.props.currentPeriod}
        />
      ),
    },
    {
      title: 'Time Saved',
      description:
        'The total time saved by the bot, calculated from the first to the last chatbot message',
      render: () => (
        <TimeSaved id="Time Saved" currentPeriod={this.props.currentPeriod} />
      ),
    },
    {
      title: 'Median Conversation Length',
      description:
        'The median duration of a conversation, calculated from the time of the first incoming message in a new conversation to the last message once closed',
      render: () => (
        <ConversationLength
          id="Median Conversation Length"
          botsConversationLength={this.props.botsConversationLength}
        />
      ),
    },
    {
      title: 'Closed Conversations',
      description:
        'Closed conversations based on the last assignment. Calculated using the date the conversation was closed',
      render: () => (
        <ClosedConversations
          id="Closed Conversations"
          currentPeriod={this.props.currentPeriod}
        />
      ),
    },
  ];

  componentDidMount() {
    updateBotsFilters({
      startDate: moment().subtract(7, 'days'),
      endDate: moment(),
    });
  }

  render() {
    return (
      <div className="Stats-Conversations">
        <GeckoRow>
          <div className="col">
            <FilterBar
              filterByDates
              filterByBots
              filterByTags
              filterByChannels
              startDate={this.props.startDateBots}
              endDate={this.props.endDateBots}
              filter={updateBotsFilters}
            />
          </div>
        </GeckoRow>
        <div className="row Stats-Conversations-cards">
          {this.renderCards()}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state, props) => {
  return {
    fetchingBotsResponses: state.statsRoute.fetchingBotsResponses,
    botsResolvedConversations: state.statsRoute.botsResolvedConversations,
    startDateBots: state.statsRoute.startDateBots,
    endDateBots: state.statsRoute.endDateBots,
    filteredTags: state.statsRoute.filteredTags,
    botsConversationLength: state.statsRoute.botsConversationLength,
    currentPeriod: state.statsRoute.botsCurrentPeriod,
  };
};
export default connect(mapStateToProps)(Bots);
